import { gql, useLazyQuery, useMutation } from "@apollo/client";

import { FragmentDefiner } from "../../../GlobalHooks/useReadFragment";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import getConfig from "next/config";
import { useUser } from "shared-components/Components/User/User.hook";
import {
	REGISTER_MUTATION,
	UPDATE_USER_MUTATION,
	USER_EXISTS_QUERY,
} from "shared-components/Components/User/User.querys";
import { getBaseDomain as loginBasePath } from "@Utils/Functions";

export const FRAGMENT_TECHNICAL_SHEET = new FragmentDefiner(
	"Property",
	`
    technicalSheet{
        field   
        text
        value
    }
    project{id}
`
);

// TODO: change here the mutation
const SEND_LEAD_MUTATION = gql`
	mutation sendLead($input: LeadInput!) {
		sendLead(input: $input) {
			id
		}
	}
`;

interface ContactInput {
	property_id: number;
	source: number;
	type: string;
	financing_information: boolean;
	message?: string;
	visit_type?: string;
	date?: string;
	utm_args?: UtmArgs;
	isAutoGenerated?: boolean;
	name?: string;
	email?: string;
	phone?: string;
}

interface UtmArgs {
	utm_content?: string | string[];
	utm_source?: string | string[];
	utm_medium?: string | string[];
	utm_campaign?: string | string[];
}

export function useTechnicalSheet({ id, utm = null }) {
	const [formCompleted, setFormCompleted] = useState(false);
	// const { loginBasePath } = getConfig().publicRuntimeConfig;
	const { user, isLoggedIn } = useUser();

	const [sendLeadMutation] = useMutation(SEND_LEAD_MUTATION, {
		onError: error => {
			console.error("useTechnicalSheet sendLead failed", error);
		},
		onCompleted: () => setFormCompleted(true),
	});

	const [
		userExistsCustomQuery,
		{ data: dataUserExistCustom, loading: userExistsCustomLoading },
	] = useLazyQuery(USER_EXISTS_QUERY, {
		fetchPolicy: "network-only",
	});

	const refreshAuth = data => {
		Cookies.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath(),
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	const [
		registerMutation,
		{ loading: registerLoading, data: dataRegisterMutation },
	] = useMutation(REGISTER_MUTATION);

	const [updateUserMutation, { loading: updateLoading }] = useMutation(UPDATE_USER_MUTATION);

	const updateUser = ({ name, phone }) => {
		return updateUserMutation({ variables: { name, phone } });
	};

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	// TODO: receive the extra fields
	const sendLead = async (field: string, extraFields?: any) => {
		let input: ContactInput = {
			type: "PROPERTY",
			property_id: id,
			message: field,
			source: 14,
			isAutoGenerated: true,
			name: extraFields?.name,
			email: extraFields?.email,
			phone: extraFields?.phone,
			financing_information: false,
		};

		if (utm && (utm.utm_campaign || utm.utm_content || utm.utm_medium || utm.utm_source)) {
			input.utm_args = {};

			if (utm.utm_campaign) {
				input.utm_args.utm_campaign = Array.isArray(utm.utm_campaign)
					? utm.utm_campaign[0]
					: utm.utm_campaign.toString();
			}
			if (utm.utm_content) {
				input.utm_args.utm_content = Array.isArray(utm.utm_content)
					? utm.utm_content[0]
					: utm.utm_content.toString();
			}
			if (utm.utm_medium) {
				input.utm_args.utm_medium = Array.isArray(utm.utm_medium)
					? utm.utm_medium[0]
					: utm.utm_medium.toString();
			}
			if (utm.utm_source) {
				input.utm_args.utm_source = Array.isArray(utm.utm_source)
					? utm.utm_source[0]
					: utm.utm_source.toString();
			}
		}

		if (!isLoggedIn) {
			return userExistsCustomQuery({ variables: { email: input.email } }).then(data => {
				if (data?.error?.message?.includes("no existe")) {
					return registerMutation({
						variables: {
							email: input.email,
							name: input.name,
						},
					})
						.then(({ data }) => {
							return updateUser({
								name: input.name,
								phone: input.phone,
							}).then(() => {
								user.refetch();
								return sendLeadMutation({
									variables: {
										input,
									},
								}).then(data => {
									user.refetch();
									return data
								});
							});
						})
						.catch(error => {
							console.error(error);
						});
				} else {
					return sendLeadMutation({
						variables: {
							input,
						},
					});
				}
			});
		}

		// TODO: send the variables here
		return sendLeadMutation({
			variables: {
				input,
			},
		});
	};

	return {
		sendLead,
		formCompleted,
	};
}
